import { Controller } from "@hotwired/stimulus"

// Theme controller - Dark mode is now the default
// Theme toggle button is hidden but can be reactivated by removing the CSS rule
export default class extends Controller {
  static targets = ["toggle", "icon"]

  connect() {
    // Initialize theme from localStorage
    this.initializeTheme()
    
    // Set initial state based on current theme
    this.updateToggleState()
  }

  initializeTheme() {
    const savedTheme = localStorage.getItem('wildlease-theme')
    
    if (savedTheme) {
      document.documentElement.setAttribute('data-theme', savedTheme)
    } else {
      // Default to dark theme if no saved theme
      document.documentElement.setAttribute('data-theme', 'dark')
    }
  }

  toggle() {
    const currentTheme = document.documentElement.getAttribute('data-theme')
    const newTheme = currentTheme === 'dark' ? 'light' : 'dark'
    
    document.documentElement.setAttribute('data-theme', newTheme)
    localStorage.setItem('wildlease-theme', newTheme)
    
    // Update toggle button state
    this.updateToggleState()
    
    // Remove inline styles that interfere with CSS custom properties
    this.removeInlineStyles()
  }

  updateToggleState() {
    const theme = document.documentElement.getAttribute('data-theme')
    
    if (this.hasToggleTarget && this.hasIconTarget) {
      if (theme === 'dark') {
        this.toggleTarget.setAttribute('data-theme-state', 'dark')
        this.iconTarget.title = 'Switch to Light Mode'
      } else {
        this.toggleTarget.setAttribute('data-theme-state', 'light')
        this.iconTarget.title = 'Switch to Dark Mode'
      }
    }
  }

  removeInlineStyles() {
    // Remove inline styles from elements that might interfere with CSS custom properties
    const elementsWithInlineStyles = document.querySelectorAll('[style*="background-color"], [style*="color"]')
    
    elementsWithInlineStyles.forEach((element) => {
      // Skip table headers and other elements that should preserve their styles
      if (element.tagName === 'TH' || 
          element.classList.contains('table-header') ||
          element.classList.contains('tabulator') ||
          element.classList.contains('tabulator-header') ||
          element.classList.contains('tabulator-col') ||
          element.classList.contains('tabulator-row') ||
          element.classList.contains('tabulator-cell') ||
          element.closest('.tabulator')) {
        return
      }
      
      // Only remove color-related inline styles, preserve other styles
      const currentStyle = element.getAttribute('style') || ''
      const stylesToKeep = currentStyle
        .split(';')
        .filter(style => {
          const trimmed = style.trim()
          return trimmed && 
                 !trimmed.includes('background-color') && 
                 !trimmed.includes('color') &&
                 !trimmed.includes('border-color')
        })
        .join(';')
      
      if (stylesToKeep) {
        element.setAttribute('style', stylesToKeep)
      } else {
        element.removeAttribute('style')
      }
    })
  }
}
